import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { TUserMeta, TUserMetaResponse, adaptUserMetaFromResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export const UserClientSortCol = {
	ID: 'id',
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TUserClientListSortCol = TTableSortCols<typeof UserClientSortCol>;

export type TUserClientQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TUserClientListSortCol;
};

export type TUserClientQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptUserClientListQueryToRequest(data: TUserClientQuery): TUserClientQueryRequest {
	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TUserClient = {
  id: number;
  lastName: string;
  firstName: string;
  thirdName?: string;
  description?: string;
	createdAt: string;
  updatedAt: string;

	user: TUserMeta;
	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TUserClientResponse = {
  id: number;
  last_name: string;
  first_name: string;
  third_name?: string;
  description?: string;
  created_at: string;
  updated_at: string;

	user: TUserMetaResponse;
	created_by: TUserMetaResponse;
	updated_by: TUserMetaResponse;
};

export type TUserClientListResponse = TListResponse<TUserClientResponse>;

export type TUserClientList = TListResponse<TUserClient>;

export type TUserClientBodyRequest = {
	userNickname: string;
	lastName?: string;
	firstName?: string;
	thirdName?: string;
	description?: string;
};

export type TUserClientRequest = {
	user_nickname: string;
	last_name?: string;
	first_name?: string;
	third_name?: string;
	description?: string;
};

export type TUserClientUpdate = {
	id: number;
	data: TUserClientBodyRequest;
};

export function adaptUserClientFromListResponse(data: TUserClientListResponse): TUserClientList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptUserClientFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptUserClientFromResponse(data: TUserClientResponse): TUserClient {
	const {
		id,
		last_name: lastName = '',
		first_name: firstName = '',
		third_name: thirdName = '',
		description,
		user: userRaw,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
		created_at: createdAt,
		updated_at: updatedAt,
	} = data;

	const user = adaptUserMetaFromResponse(userRaw);
	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		lastName,
		firstName,
		thirdName,
		description,
		user,
		createdBy,
		updatedBy,
		createdAt,
		updatedAt,
	};
}

export function adaptUserClientToRequest(data: TUserClientBodyRequest): TUserClientRequest {
	const {
		userNickname = '',
		lastName = '',
		firstName = '',
		thirdName = '',
		description = undefined,
	} = data;

	return {
		user_nickname: userNickname,
		last_name: lastName,
		first_name: firstName,
		third_name: thirdName,
		description: description,
	};
}
